<template>
  <vue-scroll class="login-page align-vertical">
    <div class="form-wrapper align-vertical-middle">
      <div class="form-box card-base card-shadow--medium">
        <img class="image-logo" :src="logoURL" alt="logo"/>

        <form @submit.prevent="submit">
          <el-input v-model="email" placeholder="Email">
            <template slot="prefix">Enter your email</template>
          </el-input>
        </form>

        <div class="flex text-center center pt-20 pb-10">
          <el-button native-type="submit" type="default" class="login-btn" @click="submit">
            Reset Password
          </el-button>
        </div>
      </div>
    </div>
  </vue-scroll>
</template>

<script>

  import feathersClient from "../../../feathers/feathers-client";

  export default {
    name: 'ForgotPassword',
    data() {
      return {
        email: ''
      }
    },
    computed: {
      logoURL(){
        return this.$store.state.branding.logoOnlyURL;
      }
    },
    methods: {
      submit() {
        if(this.email.length > 2){
          const resetService = feathersClient.service('forgot-password');
          resetService.create({ email: this.email}).then( () => {
            this.$notify({
              title: 'Success',
              message: 'Request submitted. Please check your email',
              type: 'success'
            });
            this.$router.push('login');
          })
        } else{
          this.$notify({
            title: 'Error',
            message: 'The Email?',
            type: 'error'
          });
        }
      }
    }
  }
</script>

<style lang="scss">
  @import '../../../assets/scss/_variables';

  @media (max-width: 768px) {
    .layout-container .container .view.forgot-password-page {
      margin-left: -5px;
      margin-right: -5px;
      max-width: calc(100% + 10px);
    }
  }
</style>
